import { forwardRef } from "react";
import { StyleSheet, TextInput, type TextInputProps, View } from "react-native";

import { ThemedText } from "@/components/themed-text";
import { Radius, Spacing } from "@/constants/theme";
import { useTheme } from "@/hooks/use-theme";

export type TextFieldProps = TextInputProps & {
  label?: string;
  hint?: string;
  error?: string;
};

export const TextField = forwardRef<TextInput, TextFieldProps>(
  function TextField({ label, hint, error, style, ...rest }, ref) {
    const c = useTheme();
    return (
      <View style={styles.wrap}>
        {label ? (
          <ThemedText variant="label" tone="secondary" style={styles.label}>
            {label}
          </ThemedText>
        ) : null}
        <TextInput
          ref={ref}
          placeholderTextColor={c.textMuted}
          style={[
            styles.input,
            {
              backgroundColor: c.surface,
              borderColor: error ? c.danger : c.border,
              color: c.text,
            },
            style,
          ]}
          {...rest}
        />
        {error ? (
          <ThemedText variant="caption" tone="danger" style={styles.hint}>
            {error}
          </ThemedText>
        ) : hint ? (
          <ThemedText variant="caption" tone="muted" style={styles.hint}>
            {hint}
          </ThemedText>
        ) : null}
      </View>
    );
  },
);

const styles = StyleSheet.create({
  wrap: { alignSelf: "stretch", gap: Spacing.xs },
  label: { marginLeft: Spacing.xs },
  input: {
    borderWidth: 1,
    borderRadius: Radius.md,
    paddingHorizontal: Spacing.lg,
    paddingVertical: Spacing.md,
    fontSize: 16,
    minHeight: 52,
  },
  hint: { marginLeft: Spacing.xs },
});
